import { useState } from "react";

const services = [
  {
    title: "Door Supervisors",
    subtitle: "Leisure • Hospitality • Events • Retail",
    image: "/services/door.jpg",
    points: [
      "Professional front of house presence to deter issues before they start.",
      "Queue and entry management, ID checks, and capacity control aligned with venue policy.",
      "Conflict management with a calm, customer first approach protecting staff, guests, and reputation.",
      "Support for licensed premises: incident reporting, ejections handled correctly, and liaison with management.",
      "Retail coverage focused on loss prevention, customer safety, and rapid escalation when required.",
    ],
  },
  {
    title: "Mobile Response",
    subtitle: "Site patrols • Alarm activations • Out of hours support",
    image: "/services/mobile.jpg",
    points: [
      "Mobile patrols for industrial, commercial, and residential sites visible checks that reduce risk.",
      "Scheduled perimeter inspections, access point checks, and recorded visits for accountability.",
      "Rapid response to alarm activations: attendance, assessment, and appropriate escalation.",
      "Support for vacant property monitoring, lock/unlock assistance, and incident documentation.",
      "A practical deterrent that complements static guarding and CCTV monitoring.",
    ],
  },
  {
    title: "CCTV Operatives",
    subtitle: "Monitoring • Reporting • Evidence handling",
    image: "/services/cctv.jpg",
    points: [
      "Live monitoring with strong situational awareness to identify suspicious activity early.",
      "Accurate incident logs including times, descriptions, and key actions taken.",
      "Coordinated response: communicate with on site staff, mobile units, or emergency services when required.",
      "Evidence handling best practices supporting investigations and safeguarding footage integrity.",
      "Ideal for retail, venues, events, and sites requiring consistent observation and documentation.",
    ],
  },
  {
    title: "Close Protection",
    subtitle: "Discreet protection for high profile clients",
    image: "/services/close.jpg",
    points: [
      "Close protection for artists, celebrities, executives, and private individuals requiring privacy and safety.",
      "Discreet presence with planning led security: routes, venue assessments, and contingency preparation.",
      "Crowd movement support, controlled arrivals/departures, and coordination with event teams or security.",
      "Risk aware approach: balancing client experience with practical safety measures.",
      "Professional standards and clear communication confident protection without unnecessary attention.",
    ],
  },
];

export default function Services() {
  const [active, setActive] = useState(null);

  return (
    <section
      id="services"
      className="relative border-t border-black/10 bg-white"
    >
      <div className="mx-auto max-w-6xl px-4 py-16 md:py-20">
        <h2 className="text-3xl md:text-4xl font-semibold tracking-tight mb-10">
          Services<span className="text-redAccent">.</span>
        </h2>

        {/* GRID */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 relative">
          {services.map((s, i) => (
            <button
              key={s.title}
              onClick={() => setActive(i)}
              className="relative h-32 md:h-36 rounded-2xl overflow-hidden group shadow-sm border border-black/10"
            >
              <img
                src={s.image}
                alt={s.title}
                className="absolute inset-0 w-full h-full object-cover scale-105 group-hover:scale-110 transition"
              />
              <div className="absolute inset-0 bg-black/50" />
              <div className="relative z-10 h-full flex items-center justify-center text-center px-2">
                <h3 className="text-white text-base md:text-lg font-semibold tracking-tight">
                  {s.title}
                </h3>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* EXPANDED CARD */}
      {active !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4"
          onClick={() => setActive(null)}
        >
          <div
            className="relative bg-white max-w-4xl w-full rounded-3xl overflow-hidden shadow-2xl animate-fade"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => setActive(null)}
              className="absolute top-4 right-4 z-50 bg-black text-white rounded-full w-9 h-9 grid place-items-center hover:opacity-80 cursor-pointer"
            >
              ✕
            </button>

            <div className="h-64 relative">
              <img
                src={services[active].image}
                alt=""
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/60" />
              <div className="relative z-10 p-6 text-white">
                <h3 className="text-3xl font-semibold">
                  {services[active].title}
                </h3>
                <p className="mt-2 text-white/80">
                  {services[active].subtitle}
                </p>
              </div>
            </div>

            <div className="p-8">
              <ul className="space-y-3">
                {services[active].points.map((p, i) => (
                  <li key={i} className="flex gap-3 text-sm text-black/75">
                    <span className="mt-2 h-1.5 w-1.5 rounded-full bg-redAccent" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 flex gap-3">
                <a
                  href="#contact"
                  onClick={() => setActive(null)}
                  className="rounded-xl bg-ink text-white px-6 py-3 text-sm hover:opacity-90"
                >
                  Enquire
                </a>
                <button
                  onClick={() => setActive(null)}
                  className="rounded-xl border border-black/20 px-6 py-3 text-sm"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
